<xemex-dialog-shell [title]="titleKey | translate">
  <div class="p-2">
    <span>{{ messageKey | translate }}</span>
    <div class="mt-3 p-3 bg-neutral-light rounded">
      <p class="font-semibold">{{ data.label }}</p>
    </div>
  </div>
  <mat-dialog-actions actions>
    <xemex-filled-button (click)="onConfirm()" intent="destructive">
      {{ 'general.btnRemove' | translate }}
    </xemex-filled-button>
    <xemex-outlined-button mat-dialog-close type="button">
      {{ 'general.btnCancel' | translate }}
    </xemex-outlined-button>
  </mat-dialog-actions>
</xemex-dialog-shell>
